module.exports = __webpack_public_path__ + "static/media/man_daiwei.2f5d8ec1.png";